import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const ACTIVE_CUSTOM_ITEM_COUNT_LIMIT_FLAG_KEY =
  'active-custom-item-count-limit' as const;

/**
 * Centralized feature-flag accessor for active custom item count limit behavior.
 * Keep key/default in one place to avoid drift across list/detail screens.
 */
export const useActiveCustomItemCountLimitFlag = (): boolean =>
  useBooleanFlagValue(ACTIVE_CUSTOM_ITEM_COUNT_LIMIT_FLAG_KEY, false);
